import { Flame, Leaf } from "lucide-react";

export const SambalDuel = () => (
  <section data-testid="sambal-section" aria-labelledby="sambal-heading">
    <h2 id="sambal-heading" className="sr-only">
      Dua sambal khas Bu Iyin
    </h2>
    <div className="relative grid md:grid-cols-2">
      <div className="bg-goang-deep px-6 py-16 text-goang-light sm:px-12 sm:py-20 lg:px-20">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-goang-light/70">
          Sambal 01
        </p>
        <h3 className="mt-3 flex items-center gap-3 font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          <Leaf className="h-8 w-8" aria-hidden="true" />
          Sambal Goang
        </h3>
        <p className="mt-5 max-w-md text-base leading-relaxed">
          Sambal hijau yang segar dengan aroma kencur yang langsung tercium.
          Pendamping klasik ayam goreng basah khas Bandung — ringan, wangi, dan
          bikin nasi cepat habis.
        </p>
      </div>

      <div className="bg-bawang-dark px-6 py-16 text-red-100 sm:px-12 sm:py-20 lg:px-20">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-red-200/70">
          Sambal 02
        </p>
        <h3 className="mt-3 flex items-center gap-3 font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          <Flame className="h-8 w-8" aria-hidden="true" />
          Sambal Bawang
        </h3>
        <p className="mt-5 max-w-md text-base leading-relaxed">
          Sambal bawang yang gurih dengan pedas yang lebih nendang. Untuk yang
          suka ayam gorengnya berkeringat sedikit.
        </p>
      </div>

      <p
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 hidden h-16 w-16 -translate-x-1/2 -translate-y-1/2 rotate-[-6deg] items-center justify-center rounded-full border-4 border-canvas bg-bumbu font-heading text-lg font-extrabold text-charcoal shadow-xl md:flex"
      >
        VS
      </p>
    </div>

    <p className="bg-charcoal px-5 py-4 text-center font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu-bright">
      Dua sambal sudah termasuk di setiap paket ayam
    </p>
  </section>
);
